import React from 'react';
import { Card, PageHeader } from '../../components/ui';

interface ComingSoonProps { readonly title: string; }

/** Placeholder for a routed page that hasn't been designed yet. */
const ComingSoon = ({ title }: ComingSoonProps): React.JSX.Element => <>
  <PageHeader title={title} />
  <Card title="Coming soon" padded><p className="u-m-0">This page hasn't been built yet.</p></Card>
</>;

export default ComingSoon;
